import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { useAuth } from "../../store/AuthContext";
import { api } from "../../lib/api";
import { RankStar } from "./MenuBar";

// One-time thank-you for the very first customer — shows once, then never again.
export const HonorDialog = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const due = Boolean(user?.honor?.rank) && !user.honor.thanked_at && user.role !== "admin";
  useEffect(() => { if (due) setOpen(true); }, [due]);
  if (!due) return null;
  const first = (user.name || "").trim().split(/\s+/)[0] || user.shop_name || "there";
  const close = () => { setOpen(false); api.honorAck().catch(() => {}); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="panel3d max-w-sm border-[#f0c945]/40 bg-[#121824] text-[#e8e9ec]" data-testid="honor-dialog">
        <DialogHeader className="items-center text-center">
          <RankStar rank={user.honor.rank} className="!h-14 !w-14 [&>span]:text-[22px]" />
          <DialogTitle className="pt-2 text-center text-[18px] text-[#f0c945]" data-testid="honor-title">Thank you, {first}.</DialogTitle>
          <DialogDescription className="text-center text-[13.5px] leading-relaxed text-[#c7cbd1]" data-testid="honor-body">
            You were the <b className="text-[#e8e9ec]">first shop</b> to install Xpattern and trust it with your work — before anyone else did.
            <br /><br />Every pattern cut on this software started with you. The <b className="text-[#f0c945]">#1</b> next to your name is yours for life.
            <br /><br /><span className="text-[#9aa0a8]">— Xpattern Team</span>
          </DialogDescription>
        </DialogHeader>
        <button data-testid="honor-close-btn" onClick={close} className="btn-red mt-1 w-full">Let's cut</button>
      </DialogContent>
    </Dialog>
  );
};
